class ProfileContract {
  constructor() {
    this.lengthOfService = '';
    this.startDate = '';
    this.contService = '';
    this.benefitsStart = '';
    this.jobType = '';
    this.country = '';
    this.location = '';
    this.department = '';
    this.myLineManager = '';
    this.rightToWork = '';
    this.rightToWorkExpires = '';
    this.hoursPerWeek = 0;
    this.daysPerWeek = 0;
    this.fte = 0;
    this.workPattern = '';
    this.holidayEntitlement = 0;
    this.holidayBroughtForward = 0;
    this.holidayTotalThisYear = 0;
    this.noticePeriod = '';
    this.firstName = '';
    this.lastName = '';
    this.national_insurance_no = '';
    this.salaryType = 'monthly';
    this.taxCode = '';
    this.netPay = 0.0;
    this.nationalInsurance = 0.0;
    this.pensionContribution = 0.0;
    this.grossSalary = 0.0;
    this.payeDeduction = 0.0;
    this.otherDeductions = 0.0;
  }
}
export default ProfileContract;
